'use client';

import * as styles from './stepper.css';

import clsx from 'clsx';
import useStepperValues from './hooks/use-stepper-values';

interface StepperProps {
  initialStep?: number;
  initialTotalSteps?: number;
}

interface StepItemProps {
  active?: boolean;
  completed?: boolean;
}

function Step({ active, completed }: StepItemProps) {
  if (active) return <li aria-current="step" className={clsx(styles.step, styles.activeStep)} />;
  if (completed) return <li className={clsx(styles.completedStep, styles.step)} />;
  return <li className={styles.step} />;
}

function Stepper({ initialStep = 0, initialTotalSteps = 1 }: StepperProps) {
  const { step, totalSteps } = useStepperValues({ initialStep, initialTotalSteps });

  return (
    <ol className={styles.stepper}>
      {Array(totalSteps)
        .fill(0)
        .map((_, index) => (
          <Step active={step == index} completed={step > index} key={index} />
        ))}
    </ol>
  );
}

export default Stepper;
